import type { ContourDemSource } from './terrain-layer-controller';

declare global {
  interface Window {
    mlcontour?: {
      DemSource: new (options: Record<string, unknown>) => ContourDemSource;
    };
  }
}

const CONTOUR_SCRIPT_ID = 'maplibre-contour-js';
const CONTOUR_SCRIPT_URL = 'https://unpkg.com/maplibre-contour@0.0.5/dist/index.min.js';
const MAPTERHORN_TILE_URL = '/terrain/mapterhorn/{z}/{x}/{y}.webp';

function loadScriptOnce(id: string, src: string) {
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

export async function prepareMapterhornContours(
  installPluginRuntime: () => void,
  setupContourRuntime: (source: ContourDemSource) => void
) {
  installPluginRuntime();
  await loadScriptOnce(CONTOUR_SCRIPT_ID, CONTOUR_SCRIPT_URL);
  if (!window.mlcontour) throw new Error('maplibre-contour unavailable');
  const source = new window.mlcontour.DemSource({
    url: MAPTERHORN_TILE_URL,
    encoding: 'terrarium',
    maxzoom: 12,
    worker: false
  });
  setupContourRuntime(source);
  return source;
}
